import MaterialTable, { MTableBodyRow } from '@material-table/core'
import { Chip, IconButton } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import CreateIcon from '@material-ui/icons/Create'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { getChipStyles } from '../../services/helpers'
import { tableAlternateDark } from '../../services/theme'
import { EditAddOnDialog } from '../Dialogs'

const useStyles = makeStyles((theme) => ({
    chipRow: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    addOnRow: {
        '&:hover': {
            '& .addOnButton': {
                opacity: 0.6,
                transition: 'opacity 250ms ease-in-out'
            }
        },
        '& .addOnButton': {
            color: '#777679',
            size: '12px',
            opacity: 0,
            transition: 'opacity 250ms ease-in-out'
        }
    }
}))

const RelatedVisitsTable = (props) => {
    const classes = useStyles()
    const facility = useSelector((state) => state.specific.facilities.selected)
    const { related_visits, household, pet } = props

    const mapRelatedVisits = () => {
        if (!household || !related_visits) return []
        let pets = []
        related_visits.forEach(vis => {
            if (vis.pet_ids) vis.pet_ids.forEach(id => {
                pets.push({
                    ...vis,
                    pet: household.pets.find(p => p._id === id)
                })
            })
        })

        return pets
    }

    const renderPetName = (data) => {
        return data?.pet?.name
    }

    const renderRelation = (data) => {
        if (data?.pet?._id === pet?._id) return 'Self'
        return 'Sibling'
    }

    const renderDates = (data) => {
        if (data.type === 'boarding') {
            return `${moment(data.startDate).format('MM/DD/YY')} - ${moment(data.endDate).format('MM/DD/YY')}`
        }
        return moment(data.startDate).format('MM/DD/YY')
    }

    const renderType = (data) => {

        let url = process.env.REACT_APP_ENV === 'production'
            ? 'https://admin-petcare.herokuapp.com'
            : 'https://admin-petcare-staging.herokuapp.com'

        return <a
            style={{
                textDecoration: 'none',
                fontFamily: 'Nunito',
                color: '#6B4AD6',
                fontSize: 16,
                cursor: 'pointer'
            }}
            href={`${url}/clients/${data.household_id}/appointments/${data._id}`}
            target="_blank">
            {data.type.replaceAll('_', ' ')}
        </a>
    }

    return (
        <div style={{ padding: 16, paddingTop: 0 }}>
            <div style={{
                backgroundColor: '#F9F9F9',
                padding: 16,
                borderRadius: 10
            }}>
                <MuiThemeProvider theme={tableAlternateDark}>
                    <MaterialTable
                        style={{
                            boxShadow: 'none',
                            borderRadius: '0px'
                        }}
                        options={{
                            headerStyle: {
                                color: '#1A1A35',
                                textTransform: 'uppercase',
                                fontWeight: 800,
                                fontSize: '12px',
                                lineHeight: '16px',
                                padding: '11px 24px',
                                backgroundColor: '#F9F9F9',
                            },
                            actionsColumnIndex: -1,
                            toolbarButtonAlignment: 'left',
                            searchFieldAlignment: 'left',
                            paging: false,
                            toolbar: false
                        }}
                        localization={{
                            header: {
                                actions: ''
                            }
                        }}
                        columns={
                            [
                                {
                                    title: 'Pet Name',
                                    render: (data) => renderPetName(data),
                                    cellStyle: { textTransform: 'capitalize' }
                                },
                                {
                                    title: 'Relation',
                                    render: (data) => renderRelation(data),
                                    cellStyle: { textTransform: 'capitalize' }
                                },
                                {
                                    title: 'Type',
                                    render: (data) => renderType(data),
                                    cellStyle: { textTransform: 'capitalize' }
                                },
                                {
                                    title: 'Date',
                                    render: (data) => renderDates(data),
                                    cellStyle: { textTransform: 'capitalize' }
                                },
                                {
                                    title: 'Status',
                                    render: data => data?.status?.name,
                                    cellStyle: { textTransform: 'capitalize' }
                                },
                            ]}
                        data={mapRelatedVisits()}
                    />
                </MuiThemeProvider>

            </div>
        </div>
    )
}

export default RelatedVisitsTable
